import React from "react";
import Button from "../Button";
import Modal, { ModalFooter } from "../Modal";
import { systemAlert } from "../../utils/systemAlert";
import { classnames } from "../../utils/text";
import { isFunction } from "lodash-es";

const Alert = ({
  isOpen,
  buttons,
  isButton = true,
  onClick,
  label = '확인',
  contents,
  size = 'x-sm',
  ...props
}) => {
  return (

    <Modal
      className='custom-alert'
      isOpen={isOpen}
      size={size}
      centered={false}
      {...props}
    >
      <div className="alert-contents-box">
        <div className="alert-contents">
          {contents}
        </div>
      </div>
      {(isButton || buttons) &&
        <ModalFooter>
          {buttons ?
            buttons.map((button, idx) => <Button
              key={idx}
              size={button.size || "sm"}
              color={button.color}
              style={{
                padding: '10px 24px',
                ...button.style
              }}
              className={`alert-btn ${classnames(button.className)}`}
              onClick={() => {
                if (isFunction(button.onClick)) {
                  button.onClick()
                }
                systemAlert()
              }}
            >
              {button.label}
            </Button>
            )
            :
            <Button
              size="sm"
              style={{
                padding: '10px 24px'
              }}
              className="alert-btn"
              onClick={() => {
                if (isFunction(onClick)) {
                  onClick()
                }
                systemAlert()
              }}
            >
              {label}
            </Button>
          }
        </ModalFooter>
      }
    </Modal>
  );
};

export default Alert;
